import React from 'react';
import { useMeeting } from '../../../../hooks/useMeeting';
import { Booth, Meetingroom } from '../../../../interfaces/interfaces';
import { RootState } from '../../../../reduxToolkit/store';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { trackVCardsDownloads } from '../../../../services/services';
import StatusIcon from './StatusIcon';

interface MeetingroomTemplateProps {
  meetingroom: Meetingroom;
  booth: Booth;
}

const MeetingRoomTemplate = ({ meetingroom, booth }: MeetingroomTemplateProps) => {
  const displaystatus = useSelector(({ common }: RootState) => common.meetingroomStatuses[meetingroom._id]);
  const userid = useSelector((state) => state.common.user?._id);
  const status = displaystatus || meetingroom.displaystatus;

  const { join } = useMeeting();

  function handleDownloadClicked() {
    if (meetingroom) {
      try {
        trackVCardsDownloads(meetingroom?._id, userid, booth?._id);
      } catch (err) {
        console.error(`Err > ${err}`);
      }
    }
  }

  return (
    <div className="container flex flex-col mr-16 mb-4" style={{ flex: '0 calc(50%-4px) auto' }}>
      <div className="flex">
        <StatusIcon status={status} />
        <div className="flex flex-col">
          <p className="text-[#162c5f] text-xl font-bold">{meetingroom.contactperson}</p>
          <p className="contact-position">{meetingroom.contactposition}</p>
        </div>
      </div>

      <div className="buttons mt-2">
        {status !== 'offline' && (
          <button
            onClick={() => join(meetingroom, booth, status)}
            className="bg-[#6790ce] px-2 pt-6 pb-2 text-left text-white mr-4 disabled:bg-slate-300 disabled:cursor-default">
            1:1 Meeting beitreten
          </button>
        )}
        {meetingroom.vcard && (
          <button
            className="border border-[#162c5f] text-slate-300 px-2 pt-6 pb-2"
            onClick={() => {
              window.open(`${process!.env!.baseURL!}${process!.env!.basePath!}vcard/${meetingroom.vcard._id}`, '_blank');
              handleDownloadClicked();
            }}>
            Kontaktdaten
          </button>
        )}
      </div>
    </div>
  );
};

export default MeetingRoomTemplate;
